import { FC } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import MuiIconButton from '@material-ui/core/IconButton';

import { LinkButtonProps } from './interfaces';

const LinkIconButton: FC<LinkButtonProps> = ({ children, ...rest }) => {
  return (
    <MuiIconButton component={rest.to ? RouterLink : undefined} {...rest}>
      {children}
    </MuiIconButton>
  );
};

export default LinkIconButton;
